import { TopContributorsChart } from './components/TopContributorsChart';
import { ReturnsBreakdownChart } from './components/ReturnsBreakdownChart';

import type { PortfolioDetailedReturns } from '../../hooks/usePortfolioDetailedReturns';
import { usePortfolioType } from '../../../HoldingsTable/hooks';

type Props = {
  portfolioDetailedReturns: PortfolioDetailedReturns;
};

export const PopulatedState = ({ portfolioDetailedReturns }: Props) => {
  const { detailedReturns, currencyISO } = portfolioDetailedReturns;

  const portfolioType = usePortfolioType(portfolioDetailedReturns);

  const isHoldingsPortfolio = portfolioType !== 'transaction-portfolio';

  const {
    unrealizedGains,
    realizedGains,
    dividends,
    currencyGains,
    totalGains,
  } = detailedReturns;

  return (
    <div className="grid grid-cols-1 gap-x2 md:grid-cols-2">
      <ReturnsBreakdownChart
        unrealizedGains={unrealizedGains}
        realizedGains={isHoldingsPortfolio ? null : realizedGains}
        dividends={isHoldingsPortfolio ? null : dividends}
        currencyGains={isHoldingsPortfolio ? null : currencyGains}
        totalGains={totalGains}
        currencyISO={currencyISO}
        isHoldingsPortfolio={isHoldingsPortfolio}
      />

      <TopContributorsChart
        portfolioDetailedReturns={portfolioDetailedReturns}
      />
    </div>
  );
};
